/// <reference path='docs-and-forms.module.ts' />
///<reference path="docs-and-forms.models.ts"/>
/// <reference path='../../../../typings/index.d.ts' />
///<reference path="../../components/baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../components/common/messages.ts"/>
///<reference path="../interop/interop-actions.enum.ts"/>


module Meevo.Plugins.DocsAndForms {
	import InteropActions = Meevo.Plugins.Interop.InteropActions;
	import FormTypeEnum = Meevo.Model.FormTypeEnum;
	import AppAreaEnum = Meevo.Model.AppAreaEnum;
	export class DocsAndFormsInteropService {

		static factory(): Function {
			const instance = ($rootScope: ng.IRootScopeService,
							  docsAndFormsService: DocsAndFormsService) => {
				return new DocsAndFormsInteropService(
					$rootScope,
					docsAndFormsService
				);
			};

			instance.$inject = [
				'$rootScope',
				'meevo.plugins.docsAndForms.DocsAndFormsService',
			];

			return instance;
		}

		constructor(protected $rootScope: ng.IRootScopeService,
					protected docsAndFormsService: DocsAndFormsService) {
		}

		registerEvents(postRobot: any, interopDomain: { domain: string; }) {
            postRobot.on(InteropActions.AddCustomFormField, interopDomain, (event) => {
                return this.docsAndFormsService.showAddCustomFormFieldModal(event.data)
                    .catch(err => {
                        console.warn(err);
                        return null;
                    })
            });

			postRobot.on(InteropActions.DAFShowEditCustomFormFieldModal, interopDomain, (event) => {
				const { formModel, userDefinedControl } = event.data;

				return this.docsAndFormsService.showEditCustomFormFieldModel(formModel, userDefinedControl);
			});

			postRobot.on(InteropActions.DAFShowCopyCustomFormFieldModal, interopDomain, (event) => {
				const { formModel, userDefinedControl } = event.data;

				return this.docsAndFormsService.showCopyCustomFormFieldModel(formModel, userDefinedControl);
			});

			postRobot.on(InteropActions.DAFRemoveCustomFormFieldModal, interopDomain, (event) => {
				const { userDefinedControl } = event.data;

				return this.docsAndFormsService.removeCustomFormField(userDefinedControl);
			});
            postRobot.on(InteropActions.DAFUndeleteCustomFormFieldModal, interopDomain, (event) => {
                const { userDefinedControl } = event.data;
                return this.docsAndFormsService.undeleteCustomFormField(userDefinedControl);
            });

			postRobot.on(InteropActions.CloseFormDesigner, interopDomain, event => {
				this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_FORM_DESIGNER);
			});

			postRobot.on(InteropActions.AddCustomChartField, interopDomain, (event) => {
				return this.docsAndFormsService.showAddCustomFormFieldModal(event.data)
					.catch(err => {
						console.warn(err);
						return null;
					})
			});

			postRobot.on(InteropActions.DAFShowEditCustomChartFieldModal, interopDomain, (event) => {
				const { formModel, userDefinedControl } = event.data;

				return this.docsAndFormsService.showEditCustomFormFieldModel(formModel, userDefinedControl);
			});
			postRobot.on(InteropActions.DAFShowCopyCustomChartFieldModal, interopDomain, (event) => {
				const { formModel, userDefinedControl } = event.data;
				formModel.tabTypeEnum = FormTypeEnum.Charts;
				userDefinedControl.appAreaEnum = AppAreaEnum.Charts;
				return this.docsAndFormsService.showCopyCustomFormFieldModel(formModel, userDefinedControl);
			});
			postRobot.on(InteropActions.DAFRemoveCustomChartFieldModal, interopDomain, (event) => {
				const { userDefinedControl } = event.data;

				return this.docsAndFormsService.removeCustomFormField(userDefinedControl);
			});
			postRobot.on(InteropActions.DAFUndeleteCustomChartFieldModal, interopDomain, (event) => {
				const { userDefinedControl } = event.data;
				return this.docsAndFormsService.undeleteCustomFormField(userDefinedControl);
			});

		}
	}

	angular.module('meevo.plugins.docsAndForms')
		.service('meevo.plugins.docsAndForms.DocsAndFormsInteropService', DocsAndFormsInteropService.factory());
}
